import { BaseRepository } from "@/repositories/base-repository"
import { type IActivity } from "@/interfaces/api/activity.interface"

export class ActivityRepository extends BaseRepository<IActivity> {
  resourcePath = "administration/activities"
}
